import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'as-quickedit',
  templateUrl: './quickedit.component.html',
  styleUrls: ['./quickedit.component.scss']
})
export class QuickeditComponent implements OnInit {

  @Input() label: string;
  @Input() position: string;
  @Input() width: string;
  @Input() labelColor: string;
  @Input() icon: string;

  @Output() isSubmitted = new EventEmitter() 

  isShowing = false;

  constructor() { }

  expand(){
    this.isShowing = !this.isShowing;
  }

  submit(){

    this.isSubmitted.emit(true);
    this.expand();

  }
  ngOnInit() {
  }

}
